import { useEffect, useRef, useState } from 'react'
import {
  SActionBtn,
  SDrawerOrModal,
  SGeneralForms,
  SLowcodeList,
  SMessage,
  STableActions,
} from 'shj-components'
import { config } from './config'
import {
  deleteSpecialCode,
  getProductEnums,
  getProjectPage,
  getSpecialCodes,
  projectDelete,
  projectSave,
  projectUpdateById,
  projectUpdateState,
  specialCodeAdd,
  updateSpecialCodes,
} from '@/services/product.ts'
import { apiData2Table, trimStr } from '@/utils/data.ts'
import { message, Switch } from 'antd'
import { isEmpty } from 'lodash-es'
export default function SpecialCodesManage() {
  const listRef = useRef()
  const formRef = useRef<any>()
  const [open, setOpen] = useState(false)
  const [record, setRecord] = useState({})
  const [btnLoading, setBtnLoading] = useState(false)

  const fetchList = values => {
    const { current, pageSize, ...rest } = values
    return new Promise((resolve, reject) => {
      getSpecialCodes({
        params: { pageId: current, pageSize },
        data: rest.query,
      })
        .then(res => {
          resolve(apiData2Table(res))
        })
        .catch(reject)
    })
  }
  const onAdd = () => onEdit()
  const onEdit = (record = {}) => {
    setOpen(true)
    setRecord(record)
  }

  useEffect(() => {
    if (!isEmpty(record)) formRef.current?.onFormRef().setFieldsValue(record)
    return () => {
      formRef.current?.onFormRef().resetFields()
    }
  }, [record])

  //  表格事件: 删除
  const onDel = id => {
    SMessage.confirm({
      onOk: () => {
        return deleteSpecialCode(id).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onChangeStatus = (enabled: boolean, id: string) => {
    SMessage.confirm({
      title: `${enabled ? '打开' : '关闭'}开关，将${enabled ? '启用' : '禁用'}参数，是否继续？`,
      okText: '继续',
      content: null,
      onOk: () => {
        return projectUpdateState({ enabled, idList: [id] }).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onSubmit = () => {
    formRef.current
      ?.onFormRef()
      .validateFields()
      .then(values => {
        setBtnLoading(true)
        const apiUrl = values.id ? updateSpecialCodes : specialCodeAdd
        apiUrl({ data: { ...values } })
          .then((res: any) => {
            message.success(res.message || '操作成功')
            listRef.current?.reload()
            setOpen(false)
          })
          .finally(() => setBtnLoading(false))
      })
  }

  const getStatusOptions = async () => {
    const statueEnum = await getProductEnums('com.shj.saas.plus.product.enums.StatueEnum')
    return Promise.resolve({ statueEnum })
  }

  const extensions = {
    request: { fetchList, getStatusOptions },
    events: {
      onAdd,
    },
    status: {
      selectedDisabled: ({ selectedRowKeys }: any) => !selectedRowKeys.length,
      radioDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length !== 1,
    },
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return <Switch checked={v} onClick={checked => onChangeStatus(checked, record.id)} />
      },
      optionCell(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
          </STableActions>
        )
      },
    },
  }

  return (
    <div>
      <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      <SDrawerOrModal
        title={(record.id ? '编辑' : '新增') + '特项代码'}
        mode="modal"
        open={open}
        loading={btnLoading}
        onCancel={() => setOpen(false)}
        onOk={onSubmit}
        width={500}
      >
        <SGeneralForms
          ref={formRef}
          layout={'vertical'}
          initialValues={{ enabled: true }}
          configs={[
            {
              formItem: [
                { label: 'id', name: 'id', hidden: true },
                {
                  label: '特项名称',
                  name: 'name',
                  spanCol: 24,
                  required: true,
                  rules: [{ required: true, message: '特项名称不能为空' }],
                  comConfig: {
                    onChange: e =>
                      formRef.current?.onFormRef()?.setFieldValue('name', trimStr(e.target.value)),
                  },
                },
                {
                  label: '特项代码',
                  name: 'code',
                  spanCol: 24,
                  required: true,
                  rules: [
                    { required: true, message: '特项代码不能为空' },
                    {
                      pattern: /^[a-zA-Z]+([0-9]*)?$/,
                      message: '不符合特项代码规则',
                    },
                  ],
                  comConfig: {
                    onChange: e =>
                      formRef.current?.onFormRef()?.setFieldValue('code', trimStr(e.target.value)),
                    disabled: !!record.id,
                    maxLength: 15,
                    showCount: true,
                  },
                },
                {
                  label: '是否启用',
                  name: 'enabled',
                  type: 'switch',
                  spanCol: 24,
                  required: true,
                },
                {
                  label: '描述',
                  name: 'description',
                  spanCol: 24,
                  type: 'textarea',
                  comConfig: {
                    maxLength: 100,
                    showCount: true,
                  },
                },
              ],
            },
          ]}
        />
      </SDrawerOrModal>
    </div>
  )
}
